import http from './http'
import axios from 'axios'
import { getToken } from '../utils/auth'

export const loginApi = (username, password) =>
  http.post('/admin/login', { username, password })

export const adminApi = {
  overview: () => http.get('/admin/overview'),
  kpis: (params = {}) => http.get('/admin/kpis', { params }),
  roleQuality: (params = {}) => http.get('/admin/role-quality', { params }),
  uploadRoleAvatar: (formData) =>
    http.post('/admin/upload/role-avatar', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  users: (params = {}) => http.get('/admin/users', { params }),
  userDetail: (id) => http.get(`/admin/users/${id}`),
  resetUserPassword: (id) => http.post(`/admin/users/${id}/reset-password`),
  roles: (params = {}) => http.get('/admin/roles', { params }),
  createRole: (payload) => http.post('/admin/roles', payload),
  updateRole: (id, payload) => http.put(`/admin/roles/${id}`, payload),
  deleteRole: (id) => http.delete(`/admin/roles/${id}`),
  sessionUsers: (params = {}) => http.get('/admin/sessions/users', { params }),
  sessionUserMessages: (userId, params = {}) => http.get(`/admin/sessions/users/${userId}/messages`, { params }),
  sessions: (params = {}) => http.get('/admin/sessions', { params }),
  followUps: (params = {}) => http.get('/admin/follow-ups', { params }),
  complaints: (params = {}) => http.get('/admin/complaints', { params }),
  updateComplaintStatus: (id, status, note = '') => http.put(`/admin/complaints/${id}/status`, { status, note }),
  batchUpdateComplaintStatus: (ids = [], status, note = '') => http.put('/admin/complaints/status', { ids, status, note }),
  keywordRules: (params = {}) => http.get('/admin/keyword-rules', { params }),
  createKeywordRule: (payload) => http.post('/admin/keyword-rules', payload),
  updateKeywordRule: (id, payload) => http.put(`/admin/keyword-rules/${id}`, payload),
  deleteKeywordRule: (id) => http.delete(`/admin/keyword-rules/${id}`),
  exportSessionUserMessages: (userId, params = {}) =>
    axios.get(`https://friend-api.martinself.cn/api/admin/sessions/users/${userId}/messages/export`, {
      params,
      responseType: 'blob',
      headers: {
        authorization: `Bearer ${getToken()}`
      }
    })
}
